import React from "react";
import { InfoIcon, PromotionalIcon, WarningIcon } from "../../assets/svg";
import { getValueByKey } from "../../helper/helpers";

import "./styles.scss";

const iconMapper = {
  warning: WarningIcon,
  informational: <InfoIcon />,
  promotional: <PromotionalIcon style={{ color: "#4c8833" }} />,
};

const LoginNotification = ({
  notificationType,
  displayTitle,
  displayMessage,
  notificationImage,
  link = "",
  onClose,
}) => {
  const icon = getValueByKey(iconMapper, notificationType);

  return (
    <div
      className={`login-page-notification type-${notificationType || "default"}`}
    >
      {!!notificationImage && (
        <div className="notification-image">
          <img src={notificationImage} alt="" />
        </div>
      )}
      <div className="notification-content">
        <div className="notification-title">
          {icon || null}
          <span className="title">{displayTitle}</span>
        </div>
        {!!displayMessage && (
          <div className="notification-description">{displayMessage}</div>
        )}
        <div className="notification-actions">
          {!!link && (
            <button
              type="button"
              className="notification-link-btn"
              onClick={() => window.open(link, "_blank", "noopener,noreferrer")}
            >
              Learn More
            </button>
          )}
          <button
            type="button"
            className="notification-dismiss-btn"
            onClick={onClose}
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginNotification;
